import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";
import { CaseEvent } from "./events";
import { Participation } from "./participants";

export enum CaseStageEnum {
  FWD_AUTH_CASE_REVIEW = "FWD_AUTH_CASE_REVIEW",
  CASE_REJECTED = "CASE_REJECTED",
  CREATOR_INFORMATION_ADDITION = "CREATOR_INFORMATION_ADDITION",
  FRMD_ADMIN_CASE_REVIEW = "FRMD_ADMIN_CASE_REVIEW",
  FWD_AUTH_INFORMATION_ADDITION = "FWD_AUTH_INFORMATION_ADDITION",
  FRMD_ADMIN_DO_ASSIGNMENT = "FRMD_ADMIN_DO_ASSIGNMENT",
  DO_NOMINATE_IO_APP_AUTH= "DO_NOMINATE_IO_APP_AUTH",
  FRMD_ADMIN_IO_APP_AUTH_REVIEW = "FRMD_ADMIN_IO_APP_AUTH_REVIEW",
  IO_APP_AUTH_ASSIGN_IO = "IO_APP_AUTH_ASSIGN_IO",
  IO_ASSIGNED = "IO_ASSIGNED",
  IO_SUBMIT_IR = "IO_SUBMIT_IR",
  IO_APP_AUTH_SUBMIT_ASSESSMENT = "IO_APP_AUTH_SUBMIT_ASSESSMENT",
  POST_IR_ASSESSMENT_SUBMITTED = "POST_IR_ASSESSMENT_SUBMITTED",
}

export enum CaseStageAction {
  CREATE_CASE = "CREATE_CASE",
  RETURN_CASE_WITH_INFO = "RETURN_CASE_WITH_INFO",
  ACCEPT_CREATED_CASE = "ACCEPT_CREATED_CASE",
  REJECT_CREATED_CASE = "REJECT_CREATED_CASE",
  MARK_COMPLETE_WITH_REMARKS = "MARK_COMPLETE_WITH_REMARKS",
  ACCEPT_FWD_CASE = "ACCEPT_FWD_CASE",
  REJECT_FWD_CASE = "REJECT_FWD_CASE",
  ASSIGN_DO = "ASSIGN_DO",
  ASSIGN_IO_APP_AUTH = "ASSIGN_IO_APP_AUTH",
  APPROVE_IO_APP_AUTH = "APPROVE_IO_APP_AUTH",
  ASSIGN_IO = "ASSIGN_IO",
  SUBMIT_INVESTIGATION_REPORT = "SUBMIT_INVESTIGATION_REPORT",
  SUBMIT_POST_IR_ASSESSMENT = "SUBMIT_POST_IR_ASSESSMENT",
}

export interface ActionNextStage {
  action: CaseStageAction;
  next_stage: CaseStageEnum;
}

export interface CaseStageConfig {
  stage: CaseStageEnum;
  actions: ActionNextStage[];
}

export interface CaseStageConfigsResponse {
  stage_configs: CaseStageConfig[];
}

export interface CaseStage {
  stage_id: string;
  stage: CaseStageEnum;
  entered_at: string;
  source_action: CaseStageAction;
  source_action_by?: string;
  stage_data?: { [key: string]: any };
}

export interface SaveCaseStageResponse {
  case_stage: CaseStage;
  events?: CaseEvent[];
  participants?: Participation[];
}

export interface AddStageRequest {
  stage: CaseStageEnum;
  source_action: CaseStageAction;
  stage_data?: { [key: string]: any };
}

export const CaseStagesAPI = {
  get_configs: async () => {
    const response: AxiosResponse<CaseStageConfigsResponse> =
      await axiosInstance.get(`/v1/case-stage-configs`);
    return response.data;
  },

  add: async (case_id: string, request: AddStageRequest) => {
    const response: AxiosResponse<SaveCaseStageResponse> = await axiosInstance.post(
      `/v1/cases/${case_id}/stages`,
      request,
    );
    return response.data;
  },
};
